import { render, staticRenderFns } from "./single-photo.vue?vue&type=template&id=791aae62&"
import script from "./single-photo.vue?vue&type=script&lang=ts&"
export * from "./single-photo.vue?vue&type=script&lang=ts&"
import style0 from "./single-photo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports